import { t } from '@lingui/core/macro';

import { CHANNEL_ID_PAID_SEARCH } from '@/constants/channel';
import type { FilterComponentProps } from '@/providers/TableState';

import AdGroupFilter from './AdGroupFilter';

type Props = FilterComponentProps & {
  mode?: 'multiple' | 'single';
  hasExclude?: boolean;
};

const KeywordGroupFilter = ({ mode, ...props }: Props) => {
  return (
    <AdGroupFilter
      {...props}
      channelId={CHANNEL_ID_PAID_SEARCH}
      placeholder={mode === 'single' ? t`Select Keyword Group...` : t`Select Keyword Groups...`}
      mode={mode}
      notFoundContent={t`No keyword groups were found...`}
      data-testid="keyword-group-filter"
    />
  );
};

export default KeywordGroupFilter;
